import { DeliveryConfig, DEFAULT_DELIVERY_CONFIG, DeliveryZoneConfig } from "../services/catalogService";

export interface DeliveryOption {
  id: string;
  label: string;
  type: "delivery" | "pickup";
  /** Precio por defecto (primero de `prices`) */
  price: number;
  /** Precios seleccionables: 1 para precio fijo, varios para rango */
  prices: number[];
  zone?: string;
  address?: string;
}

/** Convierte una zona (fija o rango) en su lista de precios seleccionables */
const buildZonePrices = (z: DeliveryZoneConfig): number[] => {
  if (
    z.priceMode === "rango" &&
    typeof z.priceMin === "number" &&
    typeof z.priceMax === "number"
  ) {
    const min = Math.round(z.priceMin);
    const max = Math.round(z.priceMax);
    if (max > min) {
      const count = Math.max(2, Math.min(6, max - min + 1));
      const step = Math.max(1, Math.ceil((max - min) / (count - 1)));
      const arr: number[] = [];
      for (let p = min; p <= max; p += step) arr.push(p);
      if (arr[arr.length - 1] !== max) arr.push(max);
      return arr;
    }
    return [min];
  }
  return [Number(z.price) || 0];
};

const buildZoneOption = (z: DeliveryZoneConfig): DeliveryOption => {
  const prices = buildZonePrices(z);
  return {
    id: z.id,
    label: z.label,
    type: "delivery",
    price: prices[0],
    prices,
    zone: z.label,
  };
};

/** Opciones por defecto si no hay configuración guardada o no llega la API */
export const DEFAULT_DELIVERY_OPTIONS: DeliveryOption[] = [
  {
    id: "pickup",
    label: "Pick Up",
    type: "pickup",
    price: 0,
    prices: [0],
    address: DEFAULT_DELIVERY_CONFIG.pickupAddress,
  },
  ...DEFAULT_DELIVERY_CONFIG.zones.map(buildZoneOption),
];

/** Convierte la configuración guardada en la lista de opciones de entrega */
export const buildDeliveryOptions = (config: DeliveryConfig): DeliveryOption[] => {
  const pickup: DeliveryOption = {
    id: "pickup",
    label: "Pick Up",
    type: "pickup",
    price: 0,
    prices: [0],
    address: config.pickupAddress || "Torre Porteña",
  };

  return [pickup, ...config.zones.map(buildZoneOption)];
};